<template>
  <div class="table-of-contents">
    <h1 class="mbn desktop">
      Contents
    </h1>
    <div class="desktop dark-ben-franklin-border-bottom-fat" />
    <b-collapse
      class="card home"
      animation="slide"
      :open="false"
    >
      <div
        slot="trigger"
        class="card-header"
        role="button"
      >
        <router-link 
          :to="{ name: 'Index'}"
          class="card-header-title"
        >
          <span><i class="fas fa-home" /></span>
          <span>Home</span>
        </router-link>
      </div>
    </b-collapse>
    <b-collapse
      v-for="(section, index) of longformDocument"
      :key="index"
      class="card"
      animation="slide"
      :open="openTabs.includes(index)"
    >
      <div
        slot="trigger"
        slot-scope="props"
        class="card-header"
        role="button"
        @keyup.enter="openTabsToggle(index, props.open)"
      >
        <div
          v-if="!Array.isArray(section.children)" 
          class="card-header-title"
          tabindex="0"
        >
          <span
            class="title-container"
          >
            <span
              class="top-section-number"
              v-html="section.section_number"
            />
            <span v-html="section.section_title" />
          </span>
        </div>
        <div
          v-if="Array.isArray(section.children)"
          class="card-header-title no-events"
          tabindex="0"
          @click.stop="toggle"
        >
          <router-link
            class="title-container"
            :to="{ name: 'LongformDocument', params: { section: section.section_number }}"
          >
            <span
              class="top-section-number"
              v-html="section.section_number"
            />
            <span v-html="section.section_title" />
          </router-link>
        </div>
        <a
          v-if="!Array.isArray(section.children)"
          class="card-header-icon"
        >
          <b-icon
            :icon="props.open ? 'minus' : 'plus'"
          />
        </a>
      </div>
      <div class="card-content mbl phl pbm ptn">
        <router-link 
          v-for="(section1, index1) of section.children"
          :id="toLink(section.section_title + section1.section_title)"
          :key="index1"
          class="card-header-title mbs"
          tabindex="0"
          :to="{ name: 'LongformDocument', params: { section: section.section_number }, query: { subsection: section1.section_number }}"
        >
          <span
            class="mid-section-number"
            v-html="section1.section_number"
          />
          <span v-html="section1.section_title" />
        </router-link>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'TableOfContents',
  props: {
    longformDocument: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      openTabs: [],
    };
  },
  methods: {
    openTabsToggle( index, isOpen ) {
      if(isOpen) {
        if (this.openTabs.includes(index)) {
          let indexOfItem = this.openTabs.indexOf(index);
          if (indexOfItem >= 0) {
            this.openTabs.splice( indexOfItem, 1 );
          }
        }
      } else {
        this.openTabs.push(index);
      }
    },
    toggleTableOfContents() {
      let vm = this;
      vm.$emit('toggleTableOfContents');
    },
    toLink ( text) {
      return text.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g,"").split(' ').join('-').toLowerCase();
    },
  },
};
</script>